import React from 'react';
import PropTypes from 'prop-types';

import { MATCHES_CONNECTED_STATUS } from '../../constants';
import MatchesTable from './MatchesTable';
import ManageShopifyMatches from './ManageShopifyMatches';

const ConnectedMatches = ({ baseUrl }) => (
  <ManageShopifyMatches
    linkable
    baseUrl={baseUrl}
    status={MATCHES_CONNECTED_STATUS}
  >
    <MatchesTable status={MATCHES_CONNECTED_STATUS} />
  </ManageShopifyMatches>
);

ConnectedMatches.propTypes = {
  baseUrl: PropTypes.string.isRequired,
};

export default ConnectedMatches;
